export const STATUSLUTYPE = {
    ACTIVE: 1,
    DEFAULT: 2,
    DELETED: 3,
};

export const BORROWERTYPE = {
    INDIVIDUAL: "P",
    COMPANY: "C",
    OTHER: "O"
}

